import { Component, Input, OnInit } from '@angular/core';
import { MsisdnService } from '../../../shared/msisdn/msisdn.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';

@Component({
  selector: 'cc-phone-number-recoding',
  templateUrl: './phone-number-recording.component.html',
  styleUrls: ['./phone-number-recording.component.scss']
})
export class PhoneNumberRecordingComponent implements OnInit {
  @Input() msisdn;
  @Input() plan;

  public isRecordingEnabled: boolean;

  constructor(private msisdnService: MsisdnService, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.isRecordingEnabled = this.msisdn.recording;
  }

  isRecordingPossible() {
    return this.plan.recordingsStorageDays;
  }

  onRecordingEnabledChange(event: boolean) {
    this.isRecordingEnabled = event;
    this.msisdnService.updateRecordingEnabled(this.msisdn.id, {
      recording: this.isRecordingEnabled
    });
    this.amplitudeService.logEvent('Panel:Numbers: Recording changed', { enabled: event });
  }

  recordingDisabledTooltip() {
    return this.isRecordingPossible() ? '' : 'NUMBERS.RECORDING_DISABLED_TOOLTIP';
  }
}
